module.exports = __webpack_public_path__ + "88a5a2f05fb2cb37d2f759c4fe44e84b.pdf";